import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search", "searchField", "list", "searchOptions"]

  connect() {
    this.originalList = Array.from(this.listTarget.children)
    this.performSearch()
  }

  search() {
    this.performSearch()
  }

  toggleSearchOptions(event) {
    this.searchOptionsTarget.classList.toggle("hidden")
  }

  performSearch() {
    const query = this.searchTarget.value.toLowerCase()
    const searchFields = this.searchFieldTargets.filter(cb => cb.checked).map(cb => cb.value)

    const filteredList = this.originalList.filter(row => {
      return searchFields.length === 0 || searchFields.some(field => {
        return (row.dataset[field] || "").toLowerCase().includes(query)
      })
    })

    this.updateList(filteredList)
  }

  updateList(list) {
    this.listTarget.innerHTML = ""
    list.forEach(row => this.listTarget.appendChild(row))
  }
}